import { PageSideQrCode, TopBar } from 'businessCommon/src/components';
import ThemeConfigProvider from 'common/src/config/theme/themeConfig';
import { createRoot } from 'react-dom/client';
import { IPlanPricingPageData } from './interface/pageData';
import { getAppData } from './service/planPricingService';

import CommercializePage from 'src/common/page';

import { render as footerRenderer, IFooterConfig } from '@umu/home-footer';
import { render as headerRenderer, IHeaderConfig } from '@umu/home-header';
import { trackPaymentEvent } from '@umu/umu-api';
import { ACTION_TYPE, PAGE_TYPE } from '@umu/umu-api/src/services/payment/paymentEvent';
import 'businessCommon/src/styles/businessCommon.scss';
import { langOptions } from 'common/const';
import 'common/src/styles/common.scss';
import { getMenuData } from 'plan/@planPricing/service/getMenuData';
import { App } from './app';
import './planPricingMobile.scss';

class PlanPricingMobile extends CommercializePage<IPlanPricingPageData> {
    constructor() {
        super(getAppData());
        this.render();
        trackPaymentEvent({ page_type: PAGE_TYPE.COMMODITY_UPGRADE_PAGE, action_type: ACTION_TYPE.VIEW });
    }
    public getInitState() {
        const state = {
            pageData: {
                siteHost: getAppData('siteHost'),
                userInfo: getAppData('userInfo'),
            },
        };
        return state;
    }

    public async renderHeaderAndFooter() {
        const MenuData = await getMenuData();
        this.renderHomeHeader(MenuData.header);
        this.renderFooter(MenuData.footer);
    }

    public renderHomeHeader(data: any) {
        const siteHost = getAppData('siteHost');
        const LANG = getAppData('Lang');
        const SYSTEM = getAppData('SYSTEM');
        const store = this.getInitState();
        const pageData = store.pageData;
        const userInfo = pageData.userInfo;

        // 未登录状态时，展示官网导航
        if (!(userInfo.umu_id && +userInfo.umu_id > 0)) {
            const config = {
                siteHost,
                platform: 'mobile',
                system: SYSTEM.toLocaleUpperCase(),
                lang: window.langMap[LANG as 'zh-cn'],
                headerData: data,
                langOptions,
            };
            setTimeout(() => {
                headerRenderer(config as IHeaderConfig, document.querySelector('.page-header') as HTMLElement);
            }, 100);
        }
    }

    public renderFooter(data: any) {
        const siteHost = getAppData('siteHost');
        const LANG = getAppData('Lang');
        const SYSTEM = getAppData('SYSTEM');
        const config = {
            siteHost,
            platform: 'mobile',
            system: SYSTEM.toLowerCase(),
            lang: window.langMap[LANG as 'zh-cn'],
            langOptions,
            footerData: data,
        };
        setTimeout(() => {
            footerRenderer(config as IFooterConfig, document.querySelector('.page-footer') as HTMLElement);
        }, 100);
    }

    public render() {
        const store = this.getInitState();
        const pageData = store.pageData;

        createRoot(document.querySelector('div')!).render(
            <ThemeConfigProvider>
                <div className="mobile">
                    <div className="page-header">
                        {pageData.userInfo && <TopBar userInfo={pageData.userInfo} title={''} />}
                    </div>
                    <App {...pageData}></App>
                    <PageSideQrCode />
                    <div className="page-footer"></div>
                </div>
            </ThemeConfigProvider>,
        );

        this.renderHeaderAndFooter();
    }
}
export default new PlanPricingMobile();
